import { useAuth0 } from "@auth0/auth0-vue";
import * as Sentry from "@sentry/vue";
import { defineStore } from "pinia";
import { ref } from "vue";

import sse from '@/services/sse';

export const useClockStore = defineStore("clock", () => {

  const clock = ref();
  let interval;
  let offlineInterval;
  const { getAccessTokenSilently } = useAuth0();

  const init = async function(currentTime) {
    clock.value = currentTime;

    //arriva ogni minuto
    sse.addListener('SERVER_TIME_UPDATE', data => {
      //console.log('SERVER_TIME_UPDATE ');
      refresh(data.currentTime);
      resetOfflineTimer()
    });

    startOfflineInterval();
    startReconnectInterval();
  }

  const start = function() {
    interval = setInterval(() => {
      clock.value = clock.value+1000;
    }, 1000);
  }

  const startOfflineInterval = function() {
    //console.log('startOfflineInterval');
    offlineInterval = setInterval(async () => {
      try {
        //console.log('SSE reconnected after offline period');
        await sse.reconnect(await getAccessTokenSilently());
        
        resetOfflineTimer();
      } catch (e) {
        //console.error('SSE reconnect failed:', e);
        Sentry.captureException(e);
      }
    }, 1000 * 60 * 2.5); //2.5 minutes
  }

  const startReconnectInterval = function() {
    //console.log('startReconnectInterval');
    setInterval(async () => {
      try {
        //console.log('SSE reconnected after 10 minutes');
        await sse.reconnect(await getAccessTokenSilently());
        
      } catch (e) {
        //console.error('SSE reconnect failed:', e);
        Sentry.captureException(e);
      }
    }, 1000 * 60 * 10); //10 minutes to optimze autoscaling logic
  }

  const refresh = function(seconds) {
    clearInterval(interval)
    clock.value = seconds;
    start()
  }

  const resetOfflineTimer = function() {
    //console.log('resetOfflineTimer');
    clearInterval(offlineInterval);
    startOfflineInterval();
  }

  return { clock, init, start, refresh };
});